$( document ).ready(function() {
	$("#step1").on("click", "button", function (event) {
		$("#query-string").append(this.id);
		$(this).addClass("cc-finder-button-selected");
		$(this).parent().slideUp();
		$("#step2").slideDown();
        $("#step-1-selection-display").html($(this).attr("data-display"));
	});
	$("#step2").on("click", "button", function (event) {
		$(this).addClass("cc-finder-button-selected");
		$("#query-string").append( (this.id != "" && $("#query-string").html() != "" ? '+' : "") + this.id);
		$(this).parent().slideUp();
		if ( this.id == "imp-yes" ) {
			$("#step4").slideDown();
		} else {
			$("#step3").slideDown();
		}
        $("#step-2-selection-display").html($(this).attr("data-display"));
	});
	$("#step3").on("click", "button", function (event) {
		$(this).addClass("cc-finder-button-selected");
		$("#query-string").append( (this.id != "" && $("#query-string").html() != "" ? '+' : "") + this.id);
		$(this).parent().slideUp();
		$("#step4").slideDown();
        $("#step-3-selection-display").html($(this).attr("data-display"));
	});
	$("#show-results").click(function() {
		var targetURL = "/collections/calendar-card-tracts/" + $("#query-string").html();
        $("#status-message").html("<p><i>Loading your selections ...</i></p>");
		//alert( "Target URL = " + targetURL );
		location.href=targetURL;
	});
	$("#start-over").click(function() {
		$("#query-string").html("");
        $(".cc-finder-selection").html("");
		$("#cc-finder").find("div").show();
		$(".cc-finder-step").hide();
		$("#query-string").hide();
		$("#cc-finder").find("button").removeClass("cc-finder-button-selected");
		$("#step1").slideDown();
	});
});